import { createApp } from 'vue'
import { inject } from '@vercel/analytics'

import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'

inject()




// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
})

// Routes
import routes from './pages/routes'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})


const app = createApp(App)

app.use(router)
app.use(vuetify)

app.mount('#app')

